// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Sort } from '@/constants/sort';

/**
 * A React hook that provides utility functions for sortable tables.
 *
 * @param sort.property - The current property by which the table is sorted.
 * @param sort.direction - The current direction in which the table is sorted.
 */
export function useTableSort<SortProperty extends string>(
  sort: Sort<SortProperty>
) {
  const getSortDirection = (property: SortProperty) => {
    if (property === sort.property) {
      return sort.direction;
    }

    return false;
  };

  const getLabelDirection = (property: SortProperty) => {
    if (property === sort.property) {
      return sort.direction;
    }

    return undefined;
  };

  const isLabelActive = (property: SortProperty) => {
    return property === sort.property;
  };

  return { getSortDirection, getLabelDirection, isLabelActive };
}
